/**********************************************************************************************************
 *   BASE IMPORTS
 **********************************************************************************************************/
import { useRef } from 'react'
import { FormikProps } from 'formik'
import styled from 'styled-components'
import { CreditCardIcon } from '@heroicons/react/solid'

/**********************************************************************************************************
 *   SHARED IMPORTS
 **********************************************************************************************************/
import { Tabs, Theme } from '@nexigendigital/nxui'
import { usePaymentMethodsQuery } from 'api/shop'

import CreditCardList from 'containers/shop/checkout/creditCardList'

/**********************************************************************************************************
 *   COMPONENT START
 **********************************************************************************************************/
export default function PaymentMethods() {
    const paymentMethodRef = useRef<FormikProps<{ card: string | null }>>(null)
    usePaymentMethodsQuery(undefined)

    /****************************************************
     *  FUNCTIONS
     ****************************************************/
    function handleSubmit() {
        if (paymentMethodRef.current) {
            paymentMethodRef.current.handleSubmit()
        }
    }

    return (
        <PaymentMethodsWrapper
            header={{ title: 'Payment Method' }}
            desc={'Select the payment method you would like to use.'}
            tabs={[
                {
                    label: 'Credit/Debit Card',
                    icon: CreditCardIcon,
                    render: <CreditCardList paymentMethodRef={paymentMethodRef} handleSubmit={handleSubmit}/>
                }
            ]}
        />
    )
}

/**********************************************************************************************************
 *   CUSTOM STYLING
 **********************************************************************************************************/
const PaymentMethodsWrapper = styled(Tabs)`
    margin-bottom: 0;
    
    ${props => (Theme.Functions.mediaBreakDown(props.theme['breakpoints-sm']))} {
        margin-top: 20px;
    }
    
    article {
        border-top: 1px solid ${props => props.theme['gray--100']};
        border-radius: 0;
        margin-bottom: 0;

        > footer {
            border-top: 1px solid ${props => props.theme['gray--100']};
            padding: 12px;
            display: flex;
            justify-content: space-between;
            align-items: center;
        }
    }
`
